var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeneralToolLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 151.462 197.405"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.75 0 0 75.75v121.655h7V78.649L75.75 9.9l68.712 68.712v111.793h-13.42l-31.118-31.118a30.044 30.044 0 1 0-4.769 5.131l32.987 32.987h23.32V75.712ZM59.506 157.861a22.942 22.942 0 1 1 16.224 6.722 22.8 22.8 0 0 1-16.224-6.723Z",
  "data-name": "Layer 1"
}))));
export default SvgGeneralToolLogo;